module.exports = __webpack_public_path__ + "static/media/isolated.2c527a9d.jpg";